import { useLocalSearchParams } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';
import { useAuth } from '../../../../src/contexts/AuthContext';
import { useTranslation } from '../../../../src/contexts/TranslationContext';
import { AgentPreviewCall } from '../../../../src/features/voice-agents/components/AgentPreviewCall';
import { useVoiceAgent } from '../../../../src/features/voice-agents/hooks';
import { colors } from '../../../../src/theme/colors';

export default function AgentPreviewScreen() {
  const { t } = useTranslation();
  const { id } = useLocalSearchParams<{ id: string }>();
  const { currentOrganization } = useAuth();
  const orgId = currentOrganization?.id ?? '';

  const { data: agent, isLoading } = useVoiceAgent(id ?? '', orgId);

  if (isLoading) {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.background.primary,
        }}
        accessible
        accessibilityLabel={t('voiceAgents.previewScreen.loadingA11y')}
      >
        <ActivityIndicator color={colors.primary.main} size="large" />
      </View>
    );
  }

  return (
    <AgentPreviewCall
      voiceAgentId={id ?? ''}
      agentName={agent?.name}
      backFallbackHref={id ? `/voice-agents/${id}` : '/voice-agents'}
    />
  );
}
